/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationDemographyQuery = gql`
  query GetSimulationDemographyQuery {
    getSimulationDemography_simulation_demography {
      demography {
 college  
employeeCount  
employeeAverageAge  
partnerCount  
childrenCount  
socialSecurities {
 regime  
} 
}
      colleges 
    }
  }
`;

export default GetSimulationDemographyQuery;
